import { SelectOption } from "@kanda-libs/ks-component-ts";
import { FinanceRate } from "@kanda-libs/ks-frontend-services";

const getFinanceOptionLabel = (rate: FinanceRate): string =>
  `${(rate.apr || 0) / 100}% - ${rate.duration || 0} months`;

const sortFinanceRatesByAPR = (rates: FinanceRate[]): FinanceRate[] =>
  rates.sort((a, b) => (a.apr || 0) - (b.apr || 0));

export const formatFinanceSelectOptions = (
  rates: FinanceRate[]
): SelectOption[] => {
  const options = sortFinanceRatesByAPR(rates).map((rate) => ({
    name: getFinanceOptionLabel(rate),
    value: rate.name,
  }));

  return [{ name: "", value: "" }, ...options];
};
